export const weeklyQuestFeatureSettings = {
  showSkip: true,
  showBack: false,
  doneButtonText: 'Done'
};

export const weeklyQuestFeatureIntroData = [
  {
    image: '/assets/images/survey-snacks/survey-box.png',
    title: 'Introducing Weekly Quests!',
    subtitle: 'A new way to earn even more points!'
  },
  {
    image: '/assets/images/survey-snacks/survey-message.png',
    title: 'Explore new fun activities.',
    subtitle:
      'Discover our new activity styles.\nThere is always something new!'
  },
  {
    image: '/assets/images/survey-snacks/survey-giftbox.png',
    title: 'Participate & Earn points',
    subtitle:
      'Never miss an opportunity to earn rewards.\nComplete your quests every week and get rewarded!\n\nLet’s get started!'
  }
];

export const productTestingFeatureSettings = {
  showSkip: false,
  showBack: true,
  doneButtonText: 'Let’s go!'
};

export const productTestingFeatureIntroData = [
  {
    image: '/assets/images/survey-snacks/survey-bag.png',
    title: 'Introducing\nProduct Testing!',
    subtitle:
      'As a member of our Spark community, you can now test products in your home and earn points for your feedback!'
  },
  {
    image: '/assets/images/survey-snacks/survey-faq.png',
    title: 'What do I need to do?',
    subtitle:
      "Sit back & wait for your product to show up at your door step.\nWe'll send you tracking information for your product and instructions here & via email on how to test the product."
  },
  {
    image: '/assets/images/survey-snacks/survey-giftbox.png',
    title: 'Provide feedback and earn points',
    subtitle:
      "After testing the product, you'll complete a feedback survey and earn points! As an added thanks, you get to keep the product."
  }
];
